'use client';

import { t } from 'mobx-state-tree';

import { PropertyType } from '../propertyType';

import { PropertyBase } from './propertyBase';

import type { Instance } from 'mobx-state-tree';

/** Model for boolean property */
export const BooleanProperty = t.compose('BooleanProperty', PropertyBase,
  t.model({
    type: t.literal(PropertyType.Boolean),
    value: t.optional(t.boolean, false),
    defaultValue: t.optional(t.boolean, false)
  })
).actions(self => ({
  setValue(value: boolean, fromPanel = true, initial = false) {
    if (value === self.value) return;

    self.value = value;
    self.notifyValueChange(self.path, value, { fromPanel, initial, property: self as Instance<typeof BooleanProperty> });
  },
  setDefaultValue(value: boolean) {
    self.defaultValue = value;
  }
}));